import {ChangeDetectorRef, Component, forwardRef, Input, OnInit, Output} from "@angular/core";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {FormBuilder, FormControl} from "@angular/forms";
import {AdministrationUnitService} from "../../services/administration_unit_service/administration-unit.service";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SessionActions} from "../../../shared/actions/session.actions";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Component({
  selector: 'vb-administration-unit-selection',
  templateUrl: './administration-unit-selection.component.html',
  styleUrls: ['./administration-unit-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => AdministrationUnitSelectionComponent)}]
})
export class AdministrationUnitSelectionComponent extends AbstractVisbosControl<AdministrationUnit, FormControl> implements OnInit {

  @Input()
  adminUnits: AdministrationUnit[] = [];

  @Input()
  styleClass: string;

  @Input()
  optional: boolean;

  @Output()
  itemChanged = new BehaviorSubject<AdministrationUnit>(null);

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private adminUnitService: AdministrationUnitService,
              private ngRx: NgRedux<IAppState>) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.adminUnits || this.adminUnits.length == 0) {
      // Change control value when Redux store changes, but only when no item is set
      this.addSubscription(this.activeAdminUnitCuid$.subscribe(cuid => {
        if (!this.item && this.control && this.control.pristine) {
          this.control.patchValue(cuid);
        }
      }));

      this.dataSubscriptions.push(
        this.adminUnitService.getAdminUnitsForCurrentUser().subscribe((units: any) => this.adminUnits = units)
      );
    }

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    if (this.control.pristine && !this.item && this.control.value == this.ngRx.getState().session.activeAdminUnit) {
      this.onItemChangedEvent(this.ngRx.getState().session.activeAdminUnitData);
    }
  }

  buildControlContent(values?: AdministrationUnit): FormControl {
    return AdministrationUnitSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormControl {
    return fb.control(null);
  }

  public setDefaultValues(item?: AdministrationUnit): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid', this.ngRx.getState().session.activeAdminUnit);
  }

  public onItemChangedEvent(adminUnit: AdministrationUnit) {
    this.itemChanged.next(adminUnit);
  }

}



// WEBPACK FOOTER //
// ./src/app/organization/administration_unit/administration-unit-selection/administration-unit-selection.component.ts